import Vue from 'vue'
import homeVue from '../view/home/home.vue'
import Login from '../view/login/login.vue'
import View from '../view/view/index.vue'
import DeviceIndex from '../view/device/index.vue'
import PowerStation from '../view/device/powerStation.vue'
import DeviceOne from '../view/device/deviceOne.vue'
import deviceJianCe from '../view/device/deviceJianCe.vue'
import DeviceTwo from '../view/device/deviceTwo.vue'
import deviceAnalysisVue from '../view/device/deviceAnalysis.vue'
import indexVue from '../view/home/index.vue'
import userIndex from '../view/user/index.vue'
import powerAnaly from '../view/device/powerAnaly'
import deviceStatic from '../view/device/deviceStatic.vue'
import deviceDbStatic from '../view/device/deviceDbStatic.vue'
import two from '../view/device/2.vue'
// 1. 导入告警列表组件（路径和组件名要和你实际创建的一致，建议按这个规范命名）
import warnListVue from '../view/device/warnList.vue'
import oauthClientIndex from '../view/oauthClient/index.vue'
import openApiDocIndex from '../view/openApiDoc/index.vue'
import OpenPlatformDocs from '../view/openPlatformDocs/index.vue'
import feedbackManageIndex from '../view/feedbackManage/index.vue'

const routers = [
  {
      path: '/login',
      name: 'login',
      component: Login,
	  meta:{title: '登录'}
  },
  {
      path: '/open-platform',
      redirect: '/open-platform/introduction'
  },
  {
      path: '/open-platform/introduction',
      name: 'openPlatformIntroduction',
      component: OpenPlatformDocs,
      meta: {
        title: '平台简介 - 开放平台文档',
        public: true,
        fullViewport: true,
        openPlatformSection: 'introduction'
      }
  },
  {
      path: '/open-platform/security',
      name: 'openPlatformSecurity',
      component: OpenPlatformDocs,
      meta: {
        title: '安全鉴权 - 开放平台文档',
        public: true,
        fullViewport: true,
        openPlatformSection: 'security'
      }
  },
  {
      path: '/open-platform/idempotency',
      name: 'openPlatformIdempotency',
      component: OpenPlatformDocs,
      meta: {
        title: '幂等请求 - 开放平台文档',
        public: true,
        fullViewport: true,
        openPlatformSection: 'idempotency'
      }
  },
  {
      path: '/open-platform/response',
      name: 'openPlatformResponse',
      component: OpenPlatformDocs,
      meta: {
        title: '统一响应 - 开放平台文档',
        public: true,
        fullViewport: true,
        openPlatformSection: 'response'
      }
  },
  {
      path: '/open-platform/interface/:operationId',
      name: 'openPlatformApiDetail',
      component: OpenPlatformDocs,
      meta: {
        title: '接口详情 - 开放平台文档',
        public: true,
        fullViewport: true,
        openPlatformSection: 'api'
      }
  },
  {
      path: '/two',
      name: 'two',
      component: two
  },
  {
      path: '/',
	  name: 'homeVue',
	  component: homeVue,
	  meta: { mobileFullViewport: true },
	  children:[
		  {
		  	path: '/deviceIndex',
		  	name: 'deviceIndex',
		  	component: DeviceIndex  
		  },
		  {
		  	path: '/powerStation',
		  	name: 'powerStation',
		  	component: PowerStation  
		  },
		  {
		  	path: '/deviceOne',
		  	name: 'deviceOne',
		  	component: DeviceOne  
		  },
		  {
		  	path: '/deviceTwo',
		  	name: 'deviceTwo',
		  	component: DeviceTwo  
		  },
		  {
		  	path: '/deviceJianCe',
		  	name: 'deviceJianCe',
		  	component: deviceJianCe  
		  },
		  {
		  	path: '/deviceAnalysisVue',
		  	name: 'deviceAnalysisVue',
		  	component: deviceAnalysisVue  
		  },
		  {
		  	path: '/indexVue',
		  	name: 'indexVue',
			component: indexVue
		  },
		  {
		  	path: '/userIndex',
		  	name: 'userIndex',
		  	component: userIndex  
		  },
		  {
			path: '/feedbackManageIndex',
			name: 'feedbackManageIndex',
			component: feedbackManageIndex,
        meta: { title: '反馈管理', adminOnly: true }
		  },
		  {
			path: '/openApiDocIndex',
			name: 'openApiDocIndex',
			component: openApiDocIndex,
        meta: { title: '开放接口文档' }
		  },
		  {
			path: '/oauthClientIndex',
			name: 'oauthClientIndex',
			component: oauthClientIndex,
        meta: { title: '开放接口授权' }
		  },
		  {
		  	path: '/powerAnaly',
		  	name: 'powerAnaly',
		  	component: powerAnaly  
		  },
		  {
		  	path: '/deviceStatic',
		  	name: 'deviceStatic',
		  	component: deviceStatic  
		  },
		  {
		  	path: '/deviceDbStatic',
		  	name: 'deviceDbStatic',
		  	component: deviceDbStatic  
		  },
		  {
		  	path: '/two',
		  	name: 'two',
		  	component: two  
		  },
		  // 2. 新增告警管理子路由（和其他页面同级别，路径/名称和菜单index保持一致）
		  {
		  	path: '/warnListVue',
		  	name: 'warnListVue',
		  	component: warnListVue,
        meta:{title: '告警管理'} // 可选：配置页面标题，方便全局修改title
		  }
	  ]
  }
]
export default routers
